// sbi_page_url = 'https://api.instagram.com/v1/users/1867959?access_token=1867959.1677ed0.ef8eae716af24e44845510e46e0c5e57';

// jQuery.ajax({
//     method: "GET",
//     url: sbi_page_url,
//     dataType: "jsonp",
//     success: function(data) {
//         var sbiErrorResponse = data.meta.error_message;
//         if (typeof sbiErrorResponse === 'undefined') {
//             console.log(data);
//         }
//     }
// });

if(jQuery('#instafeed').length > 0){

    var insta_feed = jQuery('#instafeed');
    var userid = insta_feed.data('insta-id');
    var token = insta_feed.data('insta-access-token');
    var num_photos = 12;

    jQuery.ajax({
        url: 'https://api.instagram.com/v1/users/' + userid + '/media/recent',
        dataType: 'jsonp',
        type: 'GET',
        data: {access_token: token, count: num_photos},
        success: function(data){
            console.log(data);
            for( x in data.data ){
                insta_feed.append('<div class="grid__item small--one-half medium--one-third large--one-sixth"><a target="_blank" href="' + data.data[x].link + '"><div class="square" style="background-image: url('+ data.data[x].images.standard_resolution.url +');"></div></a></div>'); // data.data[x].images.low_resolution.url - URL of image, 306х306
                // data.data[x].images.thumbnail.url - URL of image 150х150
                // data.data[x].images.standard_resolution.url - URL of image 612х612
                // data.data[x].link - Instagram post URL 
            }
        },
        error: function(data){
            console.log(data); // send the error notifications to console
        }
    });

}